import { graphql } from 'msw';

import { constants } from '@trqk/utils';

import { hasValidToken } from '../utils';

export const getTrqkUserInvitations = graphql.query<
    GetTrqkUserInvitationsQuery,
    GetTrqkUserInvitationsQueryVariables
>('getTrqkUserInvitations', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                getTrqkUser: {
                    id: constants.TEST_USERS.PUBLISHER.ID,
                    name: 'Test Publisher',
                    email: constants.TEST_USERS.PUBLISHER.USERNAME,
                    invitations: null,
                    __typename: 'trqkUser',
                },
            }),
        );
    }

    return res();
});
